import React from 'react';
import 'twin.macro';
import { Link } from 'gatsby';
import { Heading, Subtitle, Container } from '../atoms';

const EmptyState = ({ title, message, isShowShopButton }) => (
  <Container>
    <div tw="text-center mt-5">
      {title && (
        <Heading tw="text-center mt-2 text-2xl font-medium text-gray-900">
          {title}
        </Heading>
      )}
      {message && (
        <Subtitle tw="mt-1 text-xl text-gray-500">{message}</Subtitle>
      )}
      {isShowShopButton && (
        <Link tw="text-center mt-1 text-xl text-gray-500" to="/shop">
          Browse to our product gallery
        </Link>
      )}
    </div>
  </Container>
);

export default EmptyState;
